/** React Query hooks wrapping the Firestore queries. */
import { useQuery } from '@tanstack/react-query';
import { fetchParking } from '../services/parkings';

const STALE_FIVE_MIN = 5 * 60 * 1000;

export function useParking(parkingId: string | undefined) {
  return useQuery({
    queryKey: ['parking', parkingId],
    queryFn: () => fetchParking(parkingId!),
    enabled: !!parkingId,
    staleTime: STALE_FIVE_MIN,
  });
}
